<div (mouseenter)="this.dotComService.DisplaySubMenu('')">
    <div class="alert alert-danger alertMessageStyles80" role="alert" *ngIf="displayLoginFailure">
        <h5 *ngIf="!useZipContent" class="H5Normal" style="display:inline">{{this.failureText}}</h5>
        <h5 *ngIf="useZipContent" class="H5Normal" style="display:inline">We couldn't find a representative for that zip
            code. Please try another zip code or email <a
                href="mailto:contact@harrells.com">contact&#64;harrells.com</a> for assistance</h5>
        <h5 class="H5Normal" style="cursor:pointer;display:inline;float:right;" (click)="HideFailureAlert()">X</h5>
    </div>
    <div class="alert alert-success alertMessageStyles80" role="alert" *ngIf="displaySuccessAlert">
        <h5 class="H5Normal" style="display:inline">{{this.successText}}</h5>
        <h5 class="H5Normal" style="cursor:pointer;display:inline;float:right;" (click)="HideSuccessAlert()">X</h5>
    </div>
    <div class="row">
        <div class="d-xs d-lg-block col-lg-2 text-center"></div>
        <div class="col-xs-12 col-lg-8 text-start"><a style="font-size:20pt; text-decoration: none !important"
                href='/myharrellslogin'>
                <h3 class="col-lg-8 d-inline DIN2014Regular blueBackground  whiteText"
                    style="padding:10px;font-size:20px; text-align: left;font-weight:700">LOGIN</h3>
            </a>
        </div>
        <div class="d-xs d-lg-block col-lg-2 text-center"></div>
    </div>
    <div class="row pt-5 mb-5">
        <div class="d-xs d-lg-block col-lg-2 text-center" style="padding-top:3%"></div>
        <div class="col-lg-4 getGrowingWithAccountContainer">
            <H2 class="Caecilia76BoldItalic greenText getGrowingWithAccount">Get Growing With A
                myHarrell's Account</H2>
            <H3 class="DIN2014Regular blackText mt-3 manageAccount">The myHarrell’s online portal
                allows you to manage your Harrell’s account from anywhere at any time.</H3>
        </div>
        <div class="col-lg-4">
            <div class="row">
                <div class="col-lg-6 text-center">
                    <div class="margin:10px">
                        <img style="margin-top:5%; width:50px; padding-bottom:6px"
                            src="{{this.pageImagePaths + 'icon-one.png'}}" alt="view invoices">
                        <h4 class="DIN2014Bold blueText pb-5" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                            VIEW
                            <br>
                            INVOICES
                        </h4>
                    </div>
                    <div class="margin:10px">
                        <img style="margin-top:5%; width:50px; padding-bottom:6px"
                            src="{{this.pageImagePaths + 'icon-two.png'}}" alt="account setup image">
                        <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; line-height: 1.25;">BILL
                            & HOLD<br> DURING EOP
                        </h4>
                    </div>
                </div>
                <div class="col-lg-6 text-center">
                    <div class="margin:10px">
                        <img style="margin-top:5%; width:50px; padding-bottom:6px"
                            src="{{this.pageImagePaths + 'icon-one.png'}}" alt="account setup image">
                        <h4 class="DIN2014Bold blueText pb-5" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                            REQUEST PRODUCT
                            <br>
                            DELIVERY
                        </h4>
                    </div>
                    <div class="margin:10px">
                        <img style="margin-top:5%; width:50px; padding-bottom:6px"
                            src="{{this.pageImagePaths + 'icon-four.png'}}" alt="account setup image">
                        <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                            ACCESS CEU'S <br>ONLINE
                        </h4>
                    </div>
                </div>

            </div>
        </div>
        <div class="d-xs -lg-block col-lg-2 text-center" style="padding-top:3%"></div>
    </div>
    <div class="row pt-5 blueBackground">
        <div class="col-lg-12">
            <H3 class="Caecilia76BoldItalic whiteText" style="text-align: center; font-size:28pt">Harrell's Customers
                Can Request a myHarrell's Account</H3>
        </div>
    </div>
    <div class="blueBackground pt-4 personalInfoContainer">
        <div class="text-center" style="margin-bottom: 100px;"
            *ngIf="this.myHarrellsService.bootstrapViewPortSize != 'xs' && this.myHarrellsService.bootstrapViewPortSize != 'sm'">
            <img style="width:50px;display:inline-block" src="{{this.pageImagePaths + '1.png'}}"
                alt="account setup image">
            <h5 class="whiteText DIN2014Bold"
                style="font-size:20px; line-height:24px; display:inline-block; text-align:center;position:absolute; margin-top:60px; margin-left:-100px;">
                Provide Personal <br> Information</h5>
            <img style="width:7px;margin-left:12px;display:inline-block" src="{{this.pageImagePaths + 'ellipse.png'}}"
                alt="elipse">
            <img style="width:7px;margin-left:12px;display:inline-block" src="{{this.pageImagePaths + 'ellipse.png'}}"
                alt="elipse">
            <img style="width:7px;margin-left:12px;display:inline-block" src="{{this.pageImagePaths + 'ellipse.png'}}"
                alt="elipse">
            <img style="width:7px;margin-left:12px;display:inline-block" src="{{this.pageImagePaths + 'ellipse.png'}}"
                alt="elipse">
            <img style="width:7px;margin-left:12px;display:inline-block" src="{{this.pageImagePaths + 'ellipse.png'}}"
                alt="elipse">
            <img style="width:7px;margin-left:12px;display:inline-block" src="{{this.pageImagePaths + 'ellipse.png'}}"
                alt="elipse">
            <img style="width:7px;margin-left:12px;display:inline-block" src="{{this.pageImagePaths + 'ellipse.png'}}"
                alt="elipse">
            <img style="width:7px;margin-left:12px;display:inline-block" src="{{this.pageImagePaths + 'ellipse.png'}}"
                alt="elipse">
            <img style="width:7px;margin-left:12px;display:inline-block" src="{{this.pageImagePaths + 'ellipse.png'}}"
                alt="elipse">
            <img style="width:7px;margin-left:12px;margin-right:12px;display:inline-block"
                src="{{this.pageImagePaths + 'ellipse.png'}}" alt="elipse">

            <img style="width:50px;display:inline-block" src="{{this.pageImagePaths + '2.png'}}"
                alt="account setup image">
            <h5 class="whiteText DIN2014Bold"
                style="font-size:20px; line-height:24px; display:inline; text-align:center;position:absolute; margin-top:60px; margin-left:-100px;">
                Submit Company <br> Details</h5>
            <img style="width:7px;margin-left:12px;display:inline-block" src="{{this.pageImagePaths + 'ellipse.png'}}"
                alt="elipse">
            <img style="width:7px;margin-left:12px;display:inline-block" src="{{this.pageImagePaths + 'ellipse.png'}}"
                alt="elipse">
            <img style="width:7px;margin-left:12px;display:inline-block" src="{{this.pageImagePaths + 'ellipse.png'}}"
                alt="elipse">
            <img style="width:7px;margin-left:12px;display:inline-block" src="{{this.pageImagePaths + 'ellipse.png'}}"
                alt="elipse">
            <img style="width:7px;margin-left:12px;display:inline-block" src="{{this.pageImagePaths + 'ellipse.png'}}"
                alt="elipse">
            <img style="width:7px;margin-left:12px;display:inline-block" src="{{this.pageImagePaths + 'ellipse.png'}}"
                alt="elipse">
            <img style="width:7px;margin-left:12px;display:inline-block" src="{{this.pageImagePaths + 'ellipse.png'}}"
                alt="elipse">
            <img style="width:7px;margin-left:12px;display:inline-block" src="{{this.pageImagePaths + 'ellipse.png'}}"
                alt="elipse">
            <img style="width:7px;margin-left:12px;display:inline-block" src="{{this.pageImagePaths + 'ellipse.png'}}"
                alt="elipse">
            <img style="width:7px;margin-left:12px; margin-right:12px;display:inline-block"
                src="{{this.pageImagePaths + 'ellipse.png'}}" alt="elipse">
            <img style="width:50px;display:inline-block" src="{{this.pageImagePaths + '3.png'}}"
                alt="account setup image">
            <h5 class="whiteText DIN2014Bold"
                style="font-size:20px; line-height:24px; display:inline; text-align:center;position:absolute; margin-top:60px; margin-left:-60px;">
                Get <br> Growing</h5>
        </div>

        <div class="text-center" style="margin-bottom: 50px"
            *ngIf="this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'">
            <div class="text-center">
                <img style="width:50px;display:inline-block" src="{{this.pageImagePaths + '1.png'}}"
                    alt="account setup image">
                </div>
            <div class="text-center">
                <h5 class="whiteText DIN2014Bold"
                    style="font-size:20px; line-height:24px; display:inline-block; text-align:center;margin-top:20px">
                    Provide Personal <br> Information</h5>
            </div>
            <div class="text-center">
                <img style="width:50px;display:inline-block; margin-top:20px" src="{{this.pageImagePaths + '2.png'}}"
                    alt="account setup image">
                </div>
            <div class="text-center">
                <h5 class="whiteText DIN2014Bold"
                    style="font-size:20px; line-height:24px; display:inline-block; text-align:center;margin-top:20px">
                    Submit Company <br> Details</h5>
            </div>
            <div class="text-center">
                <img style="width:50px;display:inline-block; margin-top:20px" src="{{this.pageImagePaths + '3.png'}}"
                    alt="account setup image">
                </div>
            <div class="text-center">
                <h5 class="whiteText DIN2014Bold"
                    style="font-size:20px; line-height:24px; display:inline-block; text-align:center;margin-top:20px">
                    Get <br> Growing</h5>
            </div>
        </div>

        <div *ngIf="myHarrellsService.stage == 'CustomerQuestion'" class="mt-5 pb-5"
            style="text-align: center; width:100%">
            {{this.myHarrellsService.stage}}
            <h3 class="DIN2014Regular whiteText" style="font-size:19px; font-weight: 400;">Are you an existing
                Harrell's customer?</h3>
            <div style="text-align: center;">
                <h3 style="display:inline-block; margin-right:10px" (click)="CustomerYesClicked()">
                    <a class="DINNextLTPro-Black whiteBackground blueText"
                        style="width:90px; display:inline-block;font-size:20px;padding:8pt; text-decoration: none !important"
                        (click)="CustomerYesClicked()">YES</a>
                </h3>
                <h3 style="display:inline-block; margin-left:10px">
                    <a class="DINNextLTPro-Black whiteBackground blueText"
                        style="width:90px; display:inline-block;font-size:20px;padding:8pt; text-decoration: none !important"
                        (click)="CustomerNoClicked()">NO</a>
                </h3>
            </div>
        </div>

        <div class="mt-5 pb-5" *ngIf="myHarrellsService.stage == 'NotExistingCustomer'"
            style="margin:auto; text-align:center; max-width:1200px">

            <h3 class="DIN2014Regular whiteText" style="font-size:19px; font-weight: 400;">In order to have a myHarrells
                account, you must be a Harrell’s customer. Please reach out to your Harrell’s representative to get
                started. Click the Find My Representative button below to begin.</h3>

            <h3 style="display:inline-block; margin-right:10px">
                <a class="DINNextLTPro-Black whiteBackground blueText"
                    style="width:200px; display:inline-block;font-size:20px;padding:8pt; text-decoration: none !important"
                    href='/findrep'>FIND MY REP</a>
            </h3>
            <h3 style="display:inline-block; margin-left:10px">
                <a class="DINNextLTPro-Black whiteBackground blueText"
                    style="width:200px; display:inline-block;font-size:20px;padding:8pt; text-decoration: none !important"
                    href='/myharrellslogin'>CANCEL</a>
            </h3>
        </div>

        <div class="mt-5 pb-5" *ngIf="myHarrellsService.stage == 'CustomerInfo'"
            style="margin:auto; text-align:center; max-width:1200px">
            <div class="row col-lg-12 ml-0 mr-0">
                <h5>
                    <input Class="DIN2014Regular whiteText" [(ngModel)]="customerId"
                        style="position:relative; left:75px;width:200px;display:inline;background-color:transparent;border:solid 1px white ;padding: 17px 22px; line-height: 20px; font-size: 19px;"
                        placeholder="CUSTOMER ID*">
                    <a class="DIN2014Regular whiteText"
                        style="cursor:pointer; position:relative; top:40px; left:-95px;font-size:19px; font-weight: 400;"
                        (click)="HelpFindCustomerNmbr()">Help Me Find This</a>
                    <h3 style="position:relative; left:-55px;display:inline-block; margin-left:10px"
                        (click)="VerifyClicked()">
                        <a class="DINNextLTPro-Black whiteBackground blueText"
                            style="cursor:pointer; width:200px; display:inline-block;font-size:20px;padding:8pt; text-decoration: none !important">VERIFY</a>
                    </h3>
                </h5>
            </div>

            <div class="row" style="text-align:center" *ngIf="this.verifiedRep.Id != undefined">
                <div class="DIN2014Bold whiteText mt-5"
                    style="font-size:21px; line-height: 23px; letter-spacing: .32px">
                    Your Territory Manager
                </div>
                <div style="cursor: pointer;">
                    <!-- <div (click)="this.GoToRepDetail(rep)" style="cursor: pointer;" -->
                    <img style="height:234px;width:234px;" src={{verifiedRep.empPhoto}} alt="emp image">
                    <h5 class="DIN2014Regular whiteText"
                        style="text-transform:capitalize; font-size:21px; line-height: 23px; font-weight:700;letter-spacing: .38px; padding-top:10px">
                        {{verifiedRep.SalesRep}}</h5>
                    <h5 class="DIN2014Regular whiteText"
                        style="text-transform:uppercase; font-size:16px; line-height: 19px; font-weight:400; letter-spacing: .32px">
                        {{verifiedRep.SalesRepPhone}}</h5>
                    <h5>
                        <a class="DIN2014Regular whiteText"
                            style="font-size:16px; line-height: 19px; font-weight:700; letter-spacing: .32px"
                            href="mailto:{{verifiedRep.SalesRepEmail}}">{{verifiedRep.SalesRepEmail}}</a>
                    </h5>
                </div>
            </div>
            <div class="mt-3" *ngIf="this.assocatedMyHarrellsUsers.length > 0">
                <div class=" DIN2014Bold whiteText" style="font-size:21px; line-height: 23px; letter-spacing: .32px">
                    "Users
                    currently assocated with {{verifiedRep.CustomerName.trim()}}</div>
                <div class="mt-1">
                    <div class="row text-center" *ngFor="let user of this.assocatedMyHarrellsUsers">
                        <h5 class="DIN2014Regular whiteText"
                            style="font-size:16px; line-height: 19px; font-weight:400; letter-spacing: .32px">
                            {{user.Email}} ({{user.Name}})</h5>
                    </div>
                </div>
            </div>
            <div class=" row text-center">
                <h3 style="margin-right:10px; margin-top: 30px;" (click)="NotACustomer()">
                    <a class="DINNextLTPro-Black whiteBackground blueText"
                        style="cursor:pointer; width:420px; display:inline-block;font-size:20px;padding:8pt; text-decoration: none !important">I
                        AM NOT A CUSTOMER</a>
                </h3>
            </div>

            <!-- (click)="CustomerYesClicked()" -->
            <h3 style="display:inline-block; margin-right:10px; margin-top:10px;">
                <button class="DINNextLTPro-Black whiteBackground blueText" (click)="SubmitFromVerifyScreen()"
                    [disabled]="!this.validatedCustomer"
                    [ngClass]="!this.validatedCustomer ? 'greyDisabled': 'whiteBackground' "
                    style="cursor:pointer; width:200px; display:inline-block;font-size:20px;padding:8pt; text-decoration: none !important">SUBMIT</button>
            </h3>
            <h3 style="display:inline-block; margin-left:10px">
                <a class="DINNextLTPro-Black whiteBackground blueText"
                    style="cursor:pointer; width:200px; display:inline-block;font-size:20px;padding:8pt; text-decoration: none !important"
                    (click)="CancelCustNmbr()">CANCEL</a>
            </h3>
        </div>

        <div class="mt-5 pb-5" *ngIf="myHarrellsService.stage == 'FindCustomerNmbr'"
            style="margin:auto; text-align:center; max-width:1200px">
            <div class="row col-lg-12 ml-0 mr-0">
                <h5>
                    <input Class="DIN2014Regular whiteText" [(ngModel)]="zipCode"
                        style="margin-left:20px;width:200px;display:inline;background-color:transparent;border:solid 1px white ;padding: 17px 22px; line-height: 20px; font-size: 19px;"
                        placeholder="ZIP CODE*">
                    <h3 style="display:inline-block; margin-left:20px" (click)="ValidateZipCodeClicked()">
                        <a class="DINNextLTPro-Black whiteBackground blueText"
                            style="cursor:pointer; width:200px; display:inline-block;font-size:20px;padding:8pt; text-decoration: none !important">VALIDATE</a>
                    </h3>
                </h5>
            </div>
            <div *ngIf="!zipRepSelected" class="row mt-3 mb-3">
                <h3 *ngIf="this.zipReps.length >0" class="DIN2014Regular whiteText"
                    style="font-size:19px; font-weight: 400;">We have found the following representative(s) that service
                    the zip code you entered. Please SELECT your representative below. </h3>
                <div class="row" style="text-align:center">
                    <div class="col-lg-4" *ngFor="let rep of this.zipReps" style="margin-bottom:3%">
                        <!-- <div (click)="this.GoToRepDetail(rep)" style="cursor: pointer;"> -->
                        <div style="cursor: pointer;">
                            <img style="height:234px;width:234px;" src={{rep.empPhoto}} alt="emp image">
                            <h5 class="DIN2014Regular whiteText"
                                style="text-transform:capitalize; font-size:19px; line-height: 19px; font-weight:700;letter-spacing: .38px; padding-top:10px">
                                {{rep.SalesRep}}</h5>
                            <h5 class="DIN2014Regular whiteText"
                                style="text-transform:uppercase; font-size:16px; line-height: 19px; font-weight:400; line-height:19px; letter-spacing: .32px">
                                {{rep.SalesRepPhone}}</h5>
                            <h5><a class="DIN2014Regular whiteText"
                                    style="font-size:16px; line-height: 19px; font-weight:700; letter-spacing: .32px"
                                    href="mailto:{{rep.SalesRepEmail}}">{{rep.SalesRepEmail}}</a></h5>
                            <h5 class="DIN2014Regular whiteText"
                                style="text-transform:uppercase; font-size:16px; line-height: 19px; font-weight:400; line-height:19px; letter-spacing: .32px">
                                {{rep.SalesRepSegment}}</h5>
                            <h3 style="display:inline-block; margin-right:10px; margin-top:10px;">
                                <button class="DINNextLTPro-Black whiteBackground blueText"
                                    style="width:200px; display:inline-block;font-size:20px;padding:8pt; text-decoration: none !important"
                                    (click)="SelectedZipRep(rep)">SELECT</button>
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="zipRepSelected">
                <h3 *ngIf="this.zipReps.length >0" class="DIN2014Regular whiteText"
                    style="font-size:19px; font-weight: 400;">Select your company below. </h3>
                <!-- show the dropdown of customer that rep services  -->
                <div class="row" style="display:block; text-align:center">
                    <select class="DIN2014Regular"
                        style="font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400;width:350px; height:50px; padding-left:0px; margin-left:10px;"
                        [(ngModel)]="this.selectedZipCustNmbr">
                        <option *ngFor="let company of this.zipReps" class="DIN2014Regular"
                            value={{company.CustomerNumber}}>
                            {{company.Name}}</option>
                    </select>
                </div>
                <div class="row mt-3" style="display:block; text-align:center">
                    <!-- if the user selects the option of i dont see my company, then show the input box to enter the company -->
                    <input *ngIf="this.selectedZipCustNmbr == '99999'" Class="DIN2014Regular whiteText"
                        [(ngModel)]="manualCompanyNameEntered"
                        style="margin-left:20px;width:350px;display:inline;background-color:transparent;border:solid 1px white ;padding: 17px 22px; line-height: 20px; font-size: 19px;"
                        placeholder="Company Name*">
                </div>
            </div>
            <h3 style="display:inline-block; margin-right:10px; margin-top:10px;">
                <button class="DINNextLTPro-Black whiteBackground blueText"
                    style="width:200px; display:inline-block;font-size:20px;padding:8pt; text-decoration: none !important"
                    (click)="SubmitZipCode()">SUBMIT</button>
            </h3>
            <h3 style="display:inline-block; margin-left:10px">
                <a class="DINNextLTPro-Black whiteBackground blueText"
                    style="width:200px; display:inline-block;font-size:20px;padding:8pt; text-decoration: none !important"
                    (click)="CancelZipCode()">CANCEL</a>
            </h3>
        </div>
        <div *ngIf="myHarrellsService.stage == 'ClientInfo'" class="mt-5"
            style="margin:auto; text-align:center; max-width:1200px">
            <div class="row mt-5">
                <div class="d-xs d-lg-block col-lg-2 text-center" ></div>
                <h5 class="col-lg-4" style="display:inline"><input Class="DIN2014Regular whiteText" [(ngModel)]="email"
                        style="background-color:transparent;width:100%;border:solid 1px white ;padding: 17px 22px; line-height: 20px; font-size: 19px;"
                        placeholder="E-Mail*">
                </h5>
                <h5 class="col-lg-4" style="display:inline"><input Class="DIN2014Regular whiteText" mask="(000) 000-0000" [(ngModel)]="phone"
                        style="background-color:transparent;width:100%;border:solid 1px white ;padding: 17px 22px; line-height: 20px; font-size: 19px;"
                        placeholder="Phone">
                </h5>
                <div class="d-xs d-lg-block col-lg-2 text-center" style="padding-top:3%"></div>
            </div>
            <div class="row">
                <div class="d-xs d-lg-block col-lg-2 text-center" style="padding-top:3%"></div>
                <h5 class="col-lg-4" style="display:inline"><input Class="DIN2014Regular whiteText" [(ngModel)]="name"
                        style="background-color:transparent;width:100%;border:solid 1px white ;padding: 17px 22px; line-height: 20px; font-size: 19px;"
                        placeholder="Name*">
                </h5>
                <h5 class="col-lg-4" style="display:inline"><input type="password" Class="DIN2014Regular whiteText"
                        [(ngModel)]="password"
                        style="background-color:transparent;width:100%;border:solid 1px white ;padding: 17px 22px; line-height: 20px; font-size: 19px;"
                        placeholder="Password*">
                </h5>
                <div class="d-xs d-lg-block col-lg-2 text-center" style="padding-top:3%"></div>
            </div>
            <div class="row">
                <div class="d-xs d-lg-block col-lg-2 text-center" style="padding-top:3%"></div>
                <h5 class="col-lg-4" style="display:inline"><input Class="DIN2014Regular whiteText" [(ngModel)]="title"
                        style="background-color:transparent;width:100%;border:solid 1px white ;padding: 17px 22px; line-height: 20px; font-size: 19px;"
                        placeholder="Title">
                </h5>
                <h5 class="col-lg-4" style="display:inline"><input type="password" Class="DIN2014Regular whiteText"
                        [(ngModel)]="confirmPassword"
                        style="background-color:transparent;width:100%;border:solid 1px white ;padding: 17px 22px; line-height: 20px; font-size: 19px;"
                        placeholder="Confirm Password*">
                </h5>
                <div class="d-xs d-lg-block col-lg-2 text-center" style="padding-top:3%"></div>
            </div>
            <div class="row pt-3">
                <div class="d-xs d-lg-block col-lg-2 text-center" style="padding-top:3%"></div>
                <h3 class="col-lg-8 DIN2014Regular whiteText" style="text-align: left;"><a
                        class="DINNextLTPro-Black whiteBackground blueText"
                        style="cursor:pointer;font-size:20px;padding:8pt; text-decoration: none !important"
                        (click)="SubmitSetupClicked()">SUBMIT</a>
                </h3>
                <div class="d-xs d-lg-block col-lg-2 text-center" style="padding-top:3%"></div>
            </div>
            <div class="row pt-2 mt-3">
                <div class="d-xs d-lg-block col-lg-2 text-center" style="padding-top:3%"></div>
                <div class="col-lg-8">
                    <h3 class="DIN2014Regular whiteText text-start"
                        style="font-size: 19px; line-height: 26px; font-weight: 400;">*Activation usually takes 24
                        to 48
                        hours.</h3>
                </div>
            </div>
            <div class="row pt-2 pb-5">
                <div class="d-xs d-lg-block col-lg-2 text-center" style="padding-top:3%"></div>
                <div class="col-lg-8">
                    <h4 class="DIN2014Regular whiteText text-start" style="font-size:16px; line-height:26px">By
                        requesting a
                        myHarrell’s account, you are agreeing to
                        the <a href="{{filePaths + 'SOFTWARE_END-USER_LICENSE_AGREEMENT.pdf'}}" target="_blank"
                            style="color:white;text-decoration-line: underline;">End User License
                            Agreement</a></h4>
                </div>
            </div>
        </div>
        <div class="mt-5 pb-5" *ngIf="myHarrellsService.stage == 'ProcessingRequest'"
            style="margin:auto; text-align:center; max-width:1200px">


            <div class="row" style="text-align:center">
                <!-- <div (click)="this.GoToRepDetail(rep)" style="cursor: pointer;"> -->
                <div style="cursor: pointer;">
                    <img style="height:234px;width:234px;" src={{this.selectedZipRep.empPhoto}} alt="emp image">
                    <h5 class="DIN2014Regular whiteText"
                        style="text-transform:capitalize; font-size:19px; line-height: 19px; font-weight:700;letter-spacing: .38px; padding-top:10px">
                        {{this.selectedZipRep.SalesRep}}</h5>
                    <h5 class="DIN2014Regular whiteText"
                        style="text-transform:uppercase; font-size:16px; line-height: 19px; font-weight:400; line-height:19px; letter-spacing: .32px">
                        {{this.selectedZipRep.SalesRepPhone}}</h5>
                    <h5><a class="DIN2014Regular whiteText"
                            style="font-size:16px; line-height: 19px; font-weight:700; letter-spacing: .32px"
                            href="mailto:{{this.selectedZipRep.SalesRepEmail}}">{{this.selectedZipRep.SalesRepEmail}}</a>
                    </h5>
                    <h5 class="DIN2014Regular whiteText"
                        style="text-transform:uppercase; font-size:16px; line-height: 19px; font-weight:400; line-height:19px; letter-spacing: .32px">
                        {{this.selectedZipRep.SalesRepSegment}}</h5>

                </div>
            </div>

            <h3 class="DIN2014Regular whiteText mt-3" style="font-size:19px; font-weight: 400;">Thank you! We are
                processing
                your request. If you have any questions about the status of your myHarrell's account, please contact
                your Territory Manager.</h3>
        </div>
    </div>